;(function () {
  'use strict'

  angular.module('app').factory('GridToggleService', GridToggleService)

  function GridToggleService(
    $rootScope,
    $cookies,
    CONTRAST_GRID_COOKIE,
    CONTRAST_LIB_GRID_COOKIE,
    GRID_TOGGLED_EVENT,
    $timeout
  ) {
    'ngInject'

    return {
      toggleOldGridOn: toggleOldGridOn,
      toggleOldGridOff: toggleOldGridOff,
      isOldGridToggledOn: isOldGridToggledOn,
      removeOldGridLibToggle: removeOldGridLibToggle
    }

    function isOldGridToggledOn() {
      var cookie = $cookies.get(CONTRAST_GRID_COOKIE)
      return cookie !== 'true'
    }

    function toggleOldGridOn() {
      setCookie(false, CONTRAST_GRID_COOKIE)
      notifyToggleEvent()
    }

    function toggleOldGridOff() {
      setCookie(true, CONTRAST_GRID_COOKIE)
      notifyToggleEvent()
    }

    function notifyToggleEvent() {
      $timeout(function () {
        $rootScope.$apply()
        $rootScope.$broadcast(GRID_TOGGLED_EVENT)
      })
    }

    function removeOldGridLibToggle() {
      $cookies.remove(CONTRAST_LIB_GRID_COOKIE, { path: '/Contrast' })
    }

    function setCookie(on, name) {
      $cookies.put(name, on, {
        path: '/Contrast'
      })
    }
  }
})()
